<ion-list class="ion-no-margin ion-no-padding">
  <ion-item [disabled]="!hasGrantToWriteCustomer" button (click)="onClickEdit()">{{'EDIT'|translate}}</ion-item>
  <ion-item [disabled]="!hasGrantToWriteCustomer" button *ngIf="!customerDto.active" button (click)="onClickActivate()">{{'ACTIVATE'|translate}}</ion-item>
  <ion-item button [disabled]="!hasGrantToWriteCustomer" *ngIf="customerDto.active"  (click)="onClickDeactivate()">{{'DEACTIVATE' | translate}}</ion-item>
  <ion-item [disabled]="!hasGrantToWriteCustomer" button *ngIf="!customerDto.deleted" button (click)="onClickDelete()">{{'DELETE'|translate}}</ion-item>
</ion-list>
